<template>
  <div class="chat-tabs">
    <div class="chat-tabs__bar">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        class="chat-tabs__tab"
        :class="{ 'chat-tabs__tab--active': activeTab === tab.value }"
        @click="$emit('update:active-tab', tab.value)"
      >
        <v-icon
          x-small
          class="chat-tabs__icon"
        >
          {{ tab.icon }}
        </v-icon>
        <span class="chat-tabs__label">{{ tab.label }}</span>
        <span
          v-if="unreadCounts[tab.value] > 0"
          class="chat-tabs__badge"
        >
          {{ unreadCounts[tab.value] }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatTabs',

  props: {
    activeTab: {
      type: String,
      required: true,
    },
    unreadCounts: {
      type: Object,
      required: true,
    },
    isOrganizer: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:active-tab'],

  computed: {
    tabs() {
      const base = [
        { value: 'private', label: 'Q&A', icon: 'mdi-chat-outline' },
        { value: 'polls', label: 'Polls', icon: 'mdi-poll' },
      ];
      if (this.isOrganizer) {
        base.unshift({ value: 'organizer', label: 'Organizers', icon: 'mdi-account-group-outline' });
      }
      return base;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-tabs {
  flex-shrink: 0;
  background: #fafafa;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);

  &__bar {
    display: flex;
    width: 100%;
  }

  &__tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 10px 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    position: relative;
    transition: color 0.2s ease, background 0.2s ease;
    color: rgba(74, 74, 74, 0.6);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.02em;

    &:hover {
      background: rgba(244, 119, 33, 0.05);
      color: #4a4a4a;
    }

    &--active {
      color: #f47721;
      background: rgba(244, 119, 33, 0.06);

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 12%;
        right: 12%;
        height: 2px;
        background: #f47721;
        border-radius: 2px 2px 0 0;
      }
    }
  }

  &__icon {
    font-size: 14px !important;
    opacity: 0.8;
  }

  &__label {
    white-space: nowrap;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #f47721;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
  }
}
</style>
